import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { GET_STARTED_URL, SAMPLE_MEMO_PATH } from '../../data/dgpt';
import { HERO_POINTS } from '../../data/homeContent';
import { CtaButton } from '../ui/CtaButton';
import { Eyebrow } from '../ui/Eyebrow';
import { MemoDocument } from '../memo/MemoDocument';
export function HomeHero() {
  const reduceMotion = useReducedMotion();
  const fadeUp = (delay = 0) => reduceMotion ? {} : {
    initial: {
      opacity: 0,
      y: 14
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.55,
      delay,
      ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
    }
  };
  return <section aria-labelledby="hero-heading" className="relative overflow-hidden border-b border-hairline-soft bg-ink" data-id="element-158" data-mp="2s23ptbuyid8l">
      <div className="sf-grid-texture sf-fade-mask pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-159" data-mp="3fqwfwrowdqva" />
      <div className="relative mx-auto grid w-full max-w-[1320px] gap-12 px-4 pb-16 pt-12 sm:px-6 sm:pt-16 lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] lg:items-center lg:gap-14 lg:px-8 lg:pb-24 lg:pt-20" data-id="element-160" data-mp="3klitn1igbvij">
        <div className="flex flex-col items-start" data-id="element-161" data-mp="xniz0f6p9x4w">
          <motion.div {...fadeUp(0)} data-id="element-162" data-mp="xocaftgltatd">
            <Eyebrow data-id="element-163" data-mp="xpdpe90qqhgd">AI Due Diligence for Investment Teams</Eyebrow>
          </motion.div>
          <motion.h1 {...fadeUp(0.05)} id="hero-heading" className="mt-6 text-balance text-[42px] font-semibold leading-[1] tracking-[-0.04em] text-text-primary sm:text-[58px] lg:text-[66px]" data-id="element-164" data-mp="supyk3i9laym">
            From pitch deck to investment memo.
          </motion.h1>
          <motion.p {...fadeUp(0.1)} className="mt-6 max-w-xl text-base leading-relaxed text-text-secondary sm:text-lg" data-id="element-165" data-mp="1gk2bnegpq367">
            Screen startups, review company documents, and prepare investment assessments using your fund’s criteria.
          </motion.p>

          <motion.div {...fadeUp(0.15)} className="mt-8 flex w-full flex-col gap-3 sm:w-auto sm:flex-row" data-id="element-166" data-mp="3edr7lwk5khrd">
            <CtaButton href={GET_STARTED_URL} event="primary_cta_click" eventParams={{
            placement: 'hero',
            cta: 'try_pitch_deck_screener'
          }} size="xl" className="w-full sm:w-auto" data-id="element-167" data-mp="1hdd8ovvyoj5b">
              Try Pitch Deck Screener
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-168" data-mp="1wa4afbt3y6y3" />
            </CtaButton>
            <CtaButton href={SAMPLE_MEMO_PATH} event="sample_memo_open" eventParams={{
            placement: 'hero'
          }} variant="outline" size="xl" className="w-full sm:w-auto" data-id="element-169" data-mp="209v5vstkxb8y">
              View a Sample Investment Memo
            </CtaButton>
          </motion.div>

          <motion.ul {...fadeUp(0.2)} className="mt-8 flex flex-col gap-2.5 sm:flex-row sm:flex-wrap sm:gap-x-6" data-id="element-170" data-mp="2jyxa9jcuoyxz">
            {HERO_POINTS.map(point => <li key={point} className="flex items-center gap-2 text-sm text-text-secondary" data-id="element-171" data-mp="2nxwcgw776hlq">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#F1EFFA] text-lime" data-id="element-172" data-mp="caj1vra4r5ll">
                  <CheckIcon className="h-3 w-3" strokeWidth={2.5} aria-hidden="true" data-id="element-173" data-mp="8delduyvpj2z" />
                </span>
                {point}
              </li>)}
          </motion.ul>
        </div>

        <motion.div {...reduceMotion ? {} : {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          duration: 0.7,
          delay: 0.15,
          ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
        }
      }} className="min-w-0" data-id="element-174" data-mp="3ukla4rlo45zr">
          <MemoDocument variant="preview" titleAs="h2" data-id="element-175" data-mp="haxdfjaxwxod" />
        </motion.div>
      </div>
    </section>;
}